import { useBreakpointsContext } from '@air/provider-media-query';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export const useShowUI2Page = () => {
  const { ui2 } = useTemporaryFeatureFlags();
  const { isAboveMediumScreen } = useBreakpointsContext();

  return {
    showUI2: ui2 && isAboveMediumScreen,
  };
};
